/**
 * i18n — Phase 4
 *
 * react-i18next with English as default.
 * Language stubs: es, fr, de, pt-BR, ja, zh-Hans (English fallback strings).
 * All UI strings extracted to locales/en.json.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../locales/en.json';
import es from '../locales/es.json';
import fr from '../locales/fr.json';
import de from '../locales/de.json';
import ptBR from '../locales/pt-BR.json';
import ja from '../locales/ja.json';
import zhHans from '../locales/zh-Hans.json';

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    es: { translation: es },
    fr: { translation: fr },
    de: { translation: de },
    'pt-BR': { translation: ptBR },
    ja: { translation: ja },
    'zh-Hans': { translation: zhHans },
  },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: {
    escapeValue: false,
  },
  // Supported languages
  supportedLngs: ['en', 'es', 'fr', 'de', 'pt-BR', 'ja', 'zh-Hans'],
});

export default i18n;
